"use client";

import Link from "next/link";

import { useAuth } from "@/hooks/use-auth";

/** The footer's Account column, aware of auth state — it showed
 * "Log in / Get started" to signed-in users (2026-08-29 audit). */
export function FooterAccountLinks() {
  const { user } = useAuth();

  const links = user
    ? [
        { href: "/dashboard", label: "Dashboard" },
        { href: "/account", label: "Account" },
        { href: "/support", label: "Support" },
      ]
    : [
        { href: "/login", label: "Log in" },
        { href: "/signup", label: "Get started" },
        { href: "/support", label: "Support" },
      ];

  return (
    <ul className="mt-3 space-y-2">
      {links.map((link) => (
        <li key={link.href}>
          <Link
            href={link.href}
            className="text-body-sm text-muted hover:text-text"
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  );
}
